import React from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Typography,
  Divider,
} from "@mui/material";
import { Close, Check, Replay } from "@mui/icons-material";

const CustomDialog = ({ visible, title, message, buttons, onClose }) => {
  return (
    <Dialog
      open={visible}
      onClose={() => onClose("close")}
      aria-labelledby="custom-dialog-title"
      aria-describedby="custom-dialog-description"
      PaperProps={{
        style: {
          borderRadius: "8px",
          minWidth: "250px",
        },
      }}
    >
      <DialogTitle id="custom-dialog-title" style={{ paddingBottom: 0 }}>
        <Typography
          variant="h6"
          style={{ fontWeight: 600, textAlign: "center", marginBottom: 10 }}
        >
          {title}
        </Typography>
      </DialogTitle>
      <Divider />
      <DialogContent style={{ marginTop: "10px", textAlign: "center" }}>
        <Typography
          variant="body1"
          id="custom-dialog-description"
          style={{ fontSize: "16px" }}
        >
          {message}
        </Typography>
      </DialogContent>
      <DialogActions style={{ justifyContent: "center" }}>
        {buttons.map((button, index) => (
          <Button
            fullWidth
            key={index}
            onClick={() => {
              onClose(button.name);
              button.onPress();
            }}
            color="primary"
            variant="contained"
            style={{
              textTransform: "capitalize",
            }}
            endIcon={
              button.name === "Close" ? (
                <Close fontSize="small" />
              ) : button.name === "OK" ? (
                <Check fontSize="small" />
              ) : button.name === "Try Again" ? (
                <Replay fontSize="small" />
              ) : null
            }
          >
            {button.name}
          </Button>
        ))}
      </DialogActions>
    </Dialog>
  );
};

CustomDialog.propTypes = {
  visible: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      onPress: PropTypes.func.isRequired,
    })
  ).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default CustomDialog;
